module.exports = __webpack_public_path__ + "resources/com-status-fail.cdfd24557b02f7e8.png";